import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import IjwtStructure from '../../../Interfaces/Auth/IjwtStructure'
import jwt_decode from 'jwt-decode'
//import IMenu from '../../../Interfaces/Auth/IMenu';
const UserProfile = { token:'', logueado: false, User:'', IDUser: '', Department: '', UserType: ''  }
const initialState = { UserProfile }

export const UserProfileSlice = createSlice({
  name: 'UserProfile',
  initialState: initialState,
  reducers: {
    resetUserProfile : (state, action: PayloadAction<string>) => {
      state.UserProfile =  { token:'', logueado: false, User:'', IDUser: '', Department: '', UserType: ''  }
    },  
    populateUserProfile : (state, action: PayloadAction<string>) => {
      state.UserProfile.token = action.payload
      var values: IjwtStructure = jwt_decode(action.payload)
     /* state.UserProfile.User = JSON.stringify(values.Usuario).replaceAll('"','')
      state.UserProfile.IDUser = JSON.stringify(values.UserId).replaceAll('"','')
      state.UserProfile.Department = JSON.stringify(values.Departamento).replaceAll('"','')
      state.UserProfile.UserType = JSON.stringify(values.UserType).replaceAll('"','')*/
      state.UserProfile.logueado = true
    },
    setStatus : (state, action: PayloadAction<boolean>) => {
      state.UserProfile.logueado = action.payload
    },
  },
})

export const { resetUserProfile, populateUserProfile, setStatus } = UserProfileSlice.actions;
export default UserProfileSlice.reducer;